import React, { Component } from 'react';
import wxShare from 'wechat-shares';//微信分享插件
// import Audio from 'audio-rotate';//背景音乐
import Banner from '../banner/';
import Menus from '../menus/';
import Uploader from '../upload/';
import Footer from '../footer/';

class Main extends Component {
    componentDidMount(){
         //微信分享
        var wxoptions = {
            title_swx: '摇晃岁月的铃铛，倒叙2018的时光！', //分享标题
            desc_swx: '', //分享描述
            shareImgs: 'https://b1.qikucdn.com/dfsj_imgs/zhuanti/luyin/static/images/share.png?v=1.4', //分享图标
            serverUrl:'//bbs.360.cn/wechat/wxshare.php' //微信服务器接口地址
        }
        new wxShare(wxoptions,function(){
            console.log("分享成功后的回调函数")
        });

        // 播放音乐
        var audioptions = {
            "url": "https://b1.qikucdn.com/dfsj_imgs/zhuanti/water/static/media/water.mp3",//音频地址(必填)
            // "playicon":"",//播放图标(选填)
            // "pauseicon":"",//播放图标(选填)
            // "top":20,//定位top值(默认定位top:10px;left:10px)(选填)
            // "left":20,//定位left值(默认定位top:10px;left:10px)(选填)
            // "right":20,//定位right值(默认定位top:10px;left:10px)(选填)
            // "bottom":20,//定位bottom值(默认定位top:10px;left:10px)(选填)
		    "width":30,//播放按钮width(默认40px)(选填)
		    "height":30,//播放按钮height(默认40px)(选填)
		    // "isRotate": true, //是否旋转(选填)
		    // "speed":50 //旋转速度(选填)
        }
        // new Audio(audioptions);
    }
    render(){
        return (
            <div>
                <Menus></Menus>
                <Banner></Banner>
                <Uploader></Uploader>
                <Footer></Footer>
            </div>
        )
    }
}
export default Main;


// WEBPACK FOOTER //
// ./src/component/main/index.jsx